import { render, staticRenderFns } from "./LinkProfile.vue?vue&type=template&id=f8c44542&"
import script from "./LinkProfile.vue?vue&type=script&lang=js&"
export * from "./LinkProfile.vue?vue&type=script&lang=js&"
import style0 from "./LinkProfile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports